<mat-card class="panel_search mat-card flex-center">
    <!--sub header-->
    <div class="panel_sub_header">
        <span class="panel__header__title">Add Measurement Images</span>
    </div>
    <h1 style="display:none" mat-dialog-title>Hi {{data.compartid_auto}}</h1>
    <!--form-->
    <form class="header-form">
        <mat-form-field class="header-form-full-width">

            <input matInput placeholder="Title" name="Title_" [(ngModel)]="Title" #Title_="ngModel">

        </mat-form-field>
        <mat-form-field>
            <mat-select placeholder="Select Tool" name="ToolId_" [(ngModel)]="ToolId" #ToolId_="ngModel" required>
                <mat-option [value]="type.ToolId" *ngFor="let type of _componentservice.measurementToolsList">
                    {{type.ToolName}}
                </mat-option>
            </mat-select>
            <mat-error>Please select a Tool Used</mat-error>
        </mat-form-field>



    </form>

    <img style="width:100px; height:100px" *ngIf="ImageDataBase64" [src]="sanitize(ImageDataBase64)">

    <div class="upload-container"  title="{{'Add photo' | translate | async}}">
        <i class="material-icons upload-container__icon">
            add_a_photo
        </i>
        
        <!-- <input style="display: none;" type="file" name="ImageDataBase64" [(ngModel)]="data.ImageDataBase64" #ImageDataBase64="ngModel"
            #ImageDataBase64 (change)="onSelectPhoto($event)">  -->
           <input type="file" accept="image/*" (change)="onSelectPhoto($event)" > 
     </div>


    <div mat-dialog-actions>
        <button mat-button class="button button--primary" (click)="NoClick()">Cancel <i class="material-icons button__icon"></i><span
                class="button__text"></span></button>
        <button mat-button class="button button--primary" (click)="saveMeasurementImageDialog()" cdkFocusInitial>Save <i class="material-icons button__icon"></i><span
                class="button__text"></span></button>
    </div>
</mat-card>
